<template>
  <div class="content-info">
    <p :class="descClass" v-if="conclusionLevel">
      {{ conclusionLevel }}
    </p>
    <div class="title">
      <i :class="'iconfont' + ' ' + icon + ' ' + color"></i>
      <p>{{ title }}</p>
    </div>
    <div class="content-info-expandtext">
      <div v-html="diseaseDesc"></div>
    </div>
    <p class="content-info-tool" @click.stop="expand = !expand">
      {{ expand ? "全部" : "收起" }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    conclusionLevel: {
      // 风险等级
      type: String,
      default: "",
    },
    text: {
      // 文本内容
      type: String,
      default: "",
    },
    title: {
      // 标题
      type: String,
      default: "",
    },
    icon: {
      // icon图标
      type: String,
      default: "",
    },
    color: {
      // 颜色
      type: String,
      default: "",
    },
  },
  data() {
    return {
      expand: true, // 是否收起
      ellipsisTotal: 0, // 超出多少显示省略号
    };
  },
  computed: {
    diseaseDesc() {
      // 疾病描述 默认收起展示省略号
      const desc = this.text || "";
      if (this.expand) {
        return desc.substring(0, 100) + "...";
      } else {
        return desc;
      }
    },
    descClass() {
      // 疾病描述样式
      let levelClass = "";
      const level = this.conclusionLevel;
      switch (level) {
        case "高风险":
          levelClass = "high";
          break;
        case "较高风险":
          levelClass = "higher";
          break;
        case "一般风险":
          levelClass = "general";
          break;
        case "较低风险":
          levelClass = "lower";
          break;
        case "低分险":
          levelClass = "low";
          break;
        default:
          levelClass = "";
          break;
      }
      return ["content-info-desc", levelClass];
    },
  },
};
</script>

<style lang="scss" scoped>
.content-info {
  background-color: #fff;
  padding: 0.18rem;
  &-desc {
    font-size: 0.2rem;
    letter-spacing: 1px;
  }
  &-expandtext {
    padding: 0.1rem 0;
    margin-bottom: 0.1rem;
    font-size: 0.14rem;
  }
  &-tool {
    color: #007aff;
    text-align: right;
    cursor: pointer;
  }
  .title {
    display: flex;
    align-items: center;
    margin-bottom: 0.12rem;
    font-weight: 600;

    i {
      margin-right: 0.05rem;
    }
    .iconfont {
      font-weight: 400;
      font-size: 0.3rem;
    }
  }
  .red {
    color: #ee817d;
  }

  .orange {
    color: #ffcb80;
  }

  .pink {
    color: #ff5c5e;
  }

  .blue {
    color: #2e81fb;
  }

  .gray {
    color: #d3c4ed;
  }

  .purple {
    color: #9a75b2;
  }

  .green {
    color: #6cbc5a;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/smallGlobal/content/ContentInfo.vue